<template>
  <div class="step step-three rvr-reservation-data">
  <ReservationData />
  </div>
</template>

<script>

import useStepNavigation from "@/composables/useStepNavigation";
import ReservationData from "@/components/public/forms/ReservationData.vue";
import {watch} from "vue";
import useTexts from "@/composables/useTexts";

export default {
  name: 'PublicStepThree',
  components: {
    ReservationData,
  },
  setup() {
    const { curStep, nextButtonEnabled, nextButtonText, previousButtonPressed, goToPreviousStep } = useStepNavigation();
    curStep.value = 3;
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('PublicStepThree')

    nextButtonEnabled.value = false;
    nextButtonText.value = t.value.confirm_registration_button;


    watch(previousButtonPressed, (isPressed) => {
      if (isPressed) {
        previousButtonPressed.value = false;
        goToPreviousStep();
      }
    });

    return {
      curStep,
    };
  },
};
</script>

<style scoped>
.step {background: #e9e9e9; padding: 20px; border-radius: 4px;}
</style>
